import React from "react";
import { useSelector , useDispatch } from "react-redux";
import { addMemberAction,removeFromreq} from "../redux/slices/teamSlices";
import { userDetailAction } from "../redux/slices/userSlices";



const TeamMemberAccRej = ()=>{
    const dispatch = useDispatch();
    const userStoreData = useSelector((store)=>store.users);
    const eventStoreData = useSelector((store)=>store.event);
    const quizStoreData = useSelector((store)=>store.quiz);
    const teamStoreData = useSelector((store)=>store.team);

    const {loading : userLoading} = userStoreData;
    const {loading : eventLoading} = eventStoreData;
    const {loading : quizLoading} = quizStoreData;
    const {loading : teamLoading} = teamStoreData;

    const {user} = userStoreData;

    const addMember = async(id)=>{
        const data = {
          memberId : id,
        }
        if(!( userLoading || eventLoading || quizLoading || teamLoading )){
            await dispatch(addMemberAction(data));
            await dispatch(userDetailAction());
        }
    }
  
    const removeMemberFromqueue = async(id)=>{
        const data = {
          memberId : id,
        }

        if(!( userLoading || eventLoading || quizLoading || teamLoading )){
            await dispatch(removeFromreq(data));
            await dispatch(userDetailAction());
        }
        
    }

    return (<>
        <div className="teamreqcontain" Style="color : white">
        <h3>Team Member Requests:</h3>
        
        { user ? user?.teamRequest.map((member, index) => (
        <div id="reqs">
        <h6>{member?.email}</h6>
        <button type="button" className="btn btn-success " onClick={()=>addMember(member?.id)}>Accept</button>
        <button type="button" id="btn-delete" className="btn btn-delete bg-red-500" onClick={()=>removeMemberFromqueue(member?.id)} >Reject</button>
        </div>
            )) : <p color="white">NO requests</p> }
        </div>
    </>)
}

export default TeamMemberAccRej;